
































































































































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class Features extends Vue {
  
}
